import { ProjectMeta } from "../../data/types/api-types";
import { ProjectProgress } from "../../data/project-progress";
import { Deliverable } from "tekkr-common/dist/model/project/project";

const MILLISECONDS_IN_A_DAY = 86400000;

export function isProjectStarted(project: Pick<ProjectMeta, "status">) {
    return project.status !== "draft" && project.status !== "not_started";
}

export function isProjectCompleted(
    workstreams: Array<{ id: string }>,
    progressData: ProjectProgress | undefined
): boolean {
    if (!progressData) return false;
    return workstreams.every((ws) => progressData.getWorkstreamProgress(ws.id) === 1.0);
}

export function formatWorkstreamLetter(wsIndex: number | undefined): string | undefined {
    return wsIndex != null ? String.fromCharCode(65 + wsIndex) : undefined;
}

export function formatDeliverableId(wsIndex: number | undefined, dIndex: number | undefined): string {
    if (wsIndex != null && dIndex != null) {
        return `${String.fromCharCode(65 + wsIndex)}.${dIndex + 1}`;
    } else if (dIndex != null) {
        return `${dIndex + 1}`;
    }
    return "?";
}

export function isDeliverableDelayed(
    deliverable: Deliverable,
    progress: number
): { isDelayed: boolean; daysOverdue: number } {
    if (!deliverable.targetDate) return { isDelayed: false, daysOverdue: 0 };

    const now = new Date();
    const target = new Date(deliverable.targetDate);
    const daysOverdue = Math.floor((now.getTime() - target.getTime()) / MILLISECONDS_IN_A_DAY);

    return {
        isDelayed: daysOverdue > 0 && progress < 1.0,
        daysOverdue: Math.max(0, daysOverdue),
    };
}
